import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import axios from 'axios'
import { store } from './store'
import moment from 'moment'
// import { EmojiPickerPlugin } from 'vue-emoji-picker'

import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import money from './v-money/index'

// // Translation provided by Vuetify (javascript)
// import zhHans from 'vuetify/es5/locale/zh-Hans'

// // Translation provided by Vuetify (typescript)
// import pl from 'vuetify/src/locale/pt'

// // Your own translation file
// import sv from './i18n/vuetify/pt'

Vue.use(VCalendar, {
  componentPrefix: 'c',
  firstDayOfWeek: 1,
  locale: 'pt-br'
})

Vue.use(money, {
  decimal: ',',
  thousands: '.',
  precision: 2,
  allowBlank: true,
  masked: false
})

// export default {
//   components: {
//     EmojiIcon
//   }
// }
import { sync } from 'vuex-router-sync'

import i18n from './i18n'

sync(store, router)

const url = process.url

window.httpHeader = axios.create({
  baseURL: url,
  timeout: 200000,
  headers: {
    'Content-Type': 'application/json',
    'Token': store.getters.token
  }
})

window.axios = function axiosNewToken (token) {
  window.http = axios.create({
    baseURL: url,
    timeout: 200000,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Token': token
    }
  })
}

window.http = axios.create({
  baseURL: url,
  timeout: 200000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// axios.defaults.baseURL = url
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers.common['Token'] = store.getters.token

Vue.prototype.$http = axios.create({
  baseURL: url,
  timeout: 200000,
  paramsSerializer: function (params) {
    return JSON.stringify(params)
  }
})

Vue.use(Vuetify)

Vue.config.productionTip = false

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  i18n,
  components: { App }
})

// Vue.component('my-component', {
//   methods: {
//     changeLocale () {
//       this.$vuetify.lang.current = 'sv'
//     }
//   }
// })

// export default new Vuetify({
//   lang: {
//     locales: { zhHans, pl, sv },
//     current: 'zhHans'
//   }
// })



// WEBPACK FOOTER //
// ./src/main.js